module.exports = __webpack_public_path__ + "img/timesCircle.83e3aecf.svg";